"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marginService = void 0;
const utils_1 = require("./utils");
const marginService = {
    getProtectionOrderError: utils_1.getProtectionOrderError,
    getPriceError: utils_1.getPriceError,
    getSizeError: utils_1.getSizeError,
    distilMarginInformation: utils_1.distilMarginInformation,
    getProfitLossValue: utils_1.getProfitLossValue,
    getEstimatedDailySwapFee: utils_1.getEstimatedDailySwapFee,
    getMarginPartialCloseError: utils_1.getMarginPartialCloseError,
    getMarginRiskRating: utils_1.getMarginRiskRating,
    calculateCommission: utils_1.calculateCommission,
    calculateMarginRequirements: utils_1.calculateMarginRequirements,
    calculateMaxPositionSize: utils_1.calculateMaxPositionSize,
    isInstrumentOpen: utils_1.isInstrumentOpen,
    getInstrumentOpenTimes: utils_1.getInstrumentOpenTimes,
};
exports.marginService = marginService;
//# sourceMappingURL=index.js.map